/**
 * 发图确认页懒加载壳（14.33a，ImageViewerLazy 同模式）：确认页本体
 * （+ 14.33b~d 的编辑器）动态 import，首屏 bundle 零增量。chunk 到位前
 * 先铺一层半透明背景（点开即有反馈），可点击/Esc 取消——弱网不锁死用户。
 */
import { useLayoutEffect } from 'preact/hooks';
import { useLazyModule } from './useLazyModule';
import type { FunctionComponent } from 'preact';
import type { ImageConfirmSheetProps } from './ImageConfirmSheet';
import styles from './imageConfirm.module.scss';

export function ImageConfirmSheetLazy(props: ImageConfirmSheetProps) {
  const { mod } = useLazyModule(() => import('./ImageConfirmSheet'));
  const Sheet: FunctionComponent<ImageConfirmSheetProps> | null = mod?.ImageConfirmSheet ?? null;

  const { onCancel } = props;
  useLayoutEffect(() => {
    if (Sheet !== null) return undefined;
    const onKey = (e: KeyboardEvent): void => {
      if (e.key === 'Escape') onCancel();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [Sheet, onCancel]);

  if (Sheet === null) {
    return (
      <div
        className={styles.backdrop}
        data-testid="image-confirm-loading"
        onClick={onCancel}
      />
    );
  }
  return <Sheet {...props} />;
}
